import { downloadFile } from '@/api/files';
import { normalizeEnglishTextForTts } from '@/utils/TextNormalization';

function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
export function formatKokoroPayload(payload) {
    return {
        ...payload,
        text: normalizeEnglishTextForTts(payload.text),
    }
}

export function formatIndexTTS2Payload(payload) {
    const text = normalizeEnglishTextForTts(payload.text || '');
    const textChunks = Array.isArray(payload.text_chunks) && payload.text_chunks.length
        ? payload.text_chunks.map(chunk => normalizeEnglishTextForTts(chunk))
        : [text];
    const maxTextTokens = Number(payload.max_text_tokens_per_sentence ?? 120);

    const formatted = {
        model: payload.model,
        text,
        text_chunks: textChunks,
        emo_random: payload.emo_random ?? false,
        max_text_tokens_per_sentence: Number.isInteger(maxTextTokens) && maxTextTokens > 0
            ? maxTextTokens
            : 120,
    };

    if (payload.voice_id) {
        formatted.voice_id = payload.voice_id;
    }
    if (payload.voice_name) {
        formatted.voice_name = payload.voice_name;
    }
    if (payload.prompt_audio) {
        formatted.prompt_audio = payload.prompt_audio;
    }
    if (payload.instruct_text) {
        formatted.instruct_text = normalizeEnglishTextForTts(payload.instruct_text);
    }
    if (payload.emo_text) {
        formatted.emo_text = normalizeEnglishTextForTts(payload.emo_text);
    }
    return formatted;
}

export async function formatCosyVoicePayload(payload) {
    const {
        audio_file_id,
        instruct_text,
        model,
        text,
        voice_instruct_text,
        voice_name
    } = payload;
    const combinedInstructText = normalizeEnglishTextForTts(`${voice_instruct_text} ${instruct_text}`);
    if (!audio_file_id) {
        return {
            model,
            instruct_text: normalizeEnglishTextForTts(instruct_text),
            text: normalizeEnglishTextForTts(text),
        }
    }
    const cleanAudioId = typeof audio_file_id === 'string'
        ? audio_file_id.replace(/^"|"$/g, '')
        : audio_file_id;
    const data = await downloadFile(cleanAudioId);
    console.log('Downloaded:', cleanAudioId);

    const wavBlob = new Blob([data], { type: 'audio/wav' });
    const arrayBuffer = await wavBlob.arrayBuffer();
    const base64Audio = arrayBufferToBase64(arrayBuffer);

    return {
        model,
        audio_file_id,
        voice_name,
        voice_instruct_text,
        instruct_text: combinedInstructText,
        text: normalizeEnglishTextForTts(text),
        prompt_audio: base64Audio
    };
}
export function formatTTSPayload(payload) {
    if (
        !Object.prototype.hasOwnProperty.call(payload, 'model') ||
        typeof payload.model !== 'string' ||
        payload.model.trim() === ''
    ) {
        return payload
    }
    const modelName = payload.model.toLowerCase();
    if (modelName.includes('kokoro')) {
        const formatedPayload = formatKokoroPayload(payload);
        return formatedPayload
    }
    else if (modelName.includes('indextts2')) {
        const formatedPayload = formatIndexTTS2Payload(payload);
        return formatedPayload
    }
    else if (modelName.includes('cosyvoice')) {
        const formatedPayload = formatCosyVoicePayload(payload);
        return formatedPayload
    }
    return payload
}
